// extracted by mini-css-extract-plugin
export default {"action_data":"GrowthAction_action_data__kWw+i","textAction":"GrowthAction_textAction__Afx0D","action_box":"GrowthAction_action_box__lF5W2"};